import { useEffect } from 'react';

import { useObjectEditLayoutStore } from '../../store/objectEditLayoutStore';

export function useSyncInlineFindingEditLayout({
  findingId,
  isEditMode,
}: {
  findingId: string | undefined;
  isEditMode: boolean;
}) {
  const setInlineFindingEditId = useObjectEditLayoutStore(
    (state) => state.setInlineFindingEditId,
  );

  useEffect(() => {
    if (!findingId) {
      return;
    }

    setInlineFindingEditId(isEditMode ? findingId : null);

    return () => {
      setInlineFindingEditId(null);
    };
  }, [findingId, isEditMode, setInlineFindingEditId]);
}
